module.exports = __webpack_public_path__ + "static/themes-accents-dont-0cb6ddc47f7c077972a4f6998687ada3.png";